(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[698],{

/***/ 4931:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers",
      function () {
        return __webpack_require__(522);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mdi_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5317);
/* harmony import */ var _mdi_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8849);
/* harmony import */ var _mdi_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_mdi_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);




var JobListItem = function(param) {
    var name = param.name, location = param.location, status = param.status, date = param.date, id = param.id, _fromRelated = param.fromRelated, fromRelated = _fromRelated === void 0 ? false : _fromRelated;
    var datePublished = new Date(date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        onClick: function() {
            if (fromRelated) {
                router.replace("".concat(id));
            } else {
                router.push("careers/".concat(id));
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col border-b rounded-b-xl sm:flex-row pb-6 pt-4 md:px-5 justify-between w-full",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "p-2 flex justify-center sm:flex-none sm:justify-start",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-[#093E70] label-lg sm:label-md lg:subheading hover:cursor-pointer",
                        children: name
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid grid-cols-2 gap-3 sm:gap-0 sm:flex sm:flex-row sm:space-x-3 label-sm text-text-color-high-em",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "bg-background-low-em rounded-lg flex flex-row items-center px-[14px] py-[8px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_mdi_react__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    path: _mdi_js__WEBPACK_IMPORTED_MODULE_3__/* .mdiMapMarker */ .bTi,
                                    size: 0.7
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "ml-px",
                                    children: location
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "bg-background-low-em rounded-lg flex items-center px-[14px] py-[8px]",
                            children: status && status.toUpperCase()
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "bg-background-low-em rounded-lg flex items-center px-[14px] py-[8px]",
                            children: datePublished
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (JobListItem);


/***/ }),

/***/ 522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ careers; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/button.tsx
var components_button = __webpack_require__(6625);
// EXTERNAL MODULE: ./components/careers/job-list-item.tsx
var job_list_item = __webpack_require__(8794);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js + 3 modules
var react_final_form_es = __webpack_require__(5249);
;// CONCATENATED MODULE: ./components/form/checkbox.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var FormFieldCheckbox = function(_param) /*#__PURE__*/ {
    var label = _param.label, name = _param.name, checkboxProps = _objectWithoutProperties(_param, [
        "label",
        "name"
    ]);
    return (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
        name: name,
        type: "checkbox",
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center space-x-2 mt-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", _objectSpread({
                        name: name,
                        className: "checked:bg-secondary-light focus:ring-secondary-light focus:checked:bg-secondary-light hover:checked:bg-secondary-light rounded border-[#D0D5DD] ",
                        type: "checkbox"
                    }, input, checkboxProps)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-text-color-mid-em dark:text-text-color-low-em label-md",
                        children: label
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var form_checkbox = (FormFieldCheckbox);

// EXTERNAL MODULE: ./components/form/dropdown.tsx
var dropdown = __webpack_require__(598);
// EXTERNAL MODULE: ./components/form/input.tsx
var input = __webpack_require__(2471);
// EXTERNAL MODULE: ./components/gradient/gradient-container.tsx
var gradient_container = __webpack_require__(9467);
// EXTERNAL MODULE: ./lib/api.ts
var api = __webpack_require__(1895);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mdi/js/mdi.js
var mdi = __webpack_require__(5317);
// EXTERNAL MODULE: ./node_modules/@mdi/react/Icon.js
var Icon = __webpack_require__(8849);
var Icon_default = /*#__PURE__*/__webpack_require__.n(Icon);
// EXTERNAL MODULE: ./constants/default.ts
var constants_default = __webpack_require__(5989);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(3253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(2920);
// EXTERNAL MODULE: ./contexts/theme-context.tsx
var theme_context = __webpack_require__(9746);
;// CONCATENATED MODULE: ./pages/careers/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function careers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function careers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            careers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


















var convertJobType = function(jobTypeId) {
    switch(jobTypeId){
        case "1":
            return "Freelance";
        case "2":
            return "Full-time";
        case "3":
            return "Part-time";
        case "4":
            return "Internship";
        default:
            return "";
    }
};
var convertPostedDate = function(postedDateId) {
    switch(postedDateId){
        case "1":
            return "Today";
        case "2":
            return "Since Yesterday";
        case "3":
            return "Less than 7 days ago";
        case "4":
            return "Less than 30 days ago";
        default:
            return "";
    }
};
var convertCategory = function(categoryId) {
    switch(categoryId){
        case "1":
            return "Default";
        default:
            return "";
    }
};
var RadioButton = function(param1) {
    var groupName = param1.groupName, value = param1.value, label = param1.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
        name: groupName,
        type: "input",
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row space-x-1 items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", careers_objectSpread({
                        className: "h-4 w-4 border-1 border-gray-300\n         text-secondary\n         checked:border-white\n         checked:bg-secondary\n         checked:ring-secondary\n          checked:ring-1\n        "
                    }, input, {
                        value: value,
                        type: "radio",
                        required: true
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-body-md text-text-color-mid-em",
                        children: label
                    })
                ]
            });
        }
    });
};
var CareersPage = function() {
    var ref = (0,react.useState)(false), isAdvance = ref[0], setIsAdvance = ref[1];
    var ref1 = (0,react.useState)([]), jobsList = ref1[0], setJobsList = ref1[1];
    var ref2 = (0,react.useState)(0), totalJobs = ref2[0], setTotal = ref2[1];
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(false), isLoadMoreLoading = ref4[0], setLoadMoreLoading = ref4[1];
    var ref5 = (0,react.useState)(2), currentPage = ref5[0], setCurrentPage = ref5[1];
    var ref6 = (0,react.useState)(false), isAdvanceSearchResult = ref6[0], setIsAdvanceSearchResult = ref6[1];
    var ref7 = (0,react.useState)("web/jobs?take=10"), currentUrl = ref7[0], setCurrentUrl = ref7[1];
    var ref8 = (0,react.useState)(), searchFilters = ref8[0], setSearchFilters = ref8[1];
    var ref9 = (0,react.useState)(false), isModalOpen = ref9[0], setIsModalOpen = ref9[1];
    var ref10 = (0,theme_context/* useThemeContext */.TC)(), isMobile = ref10.isMobile, isTablet = ref10.isTablet;
    var getJobs = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        _ctx.next = 4;
                        return api/* frontendApi.get */.mR.get(currentUrl).then(function(res) {
                            setJobsList(res.data.jobs);
                            setTotal(res.data.total);
                        }).catch(function(err) {
                            return console.error(err ? err : "Something went wrong");
                        });
                    case 4:
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 9:
                        _ctx.prev = 9;
                        setLoading(false);
                        return _ctx.finish(9);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6,
                    9,
                    12
                ]
            ]);
        }));
        return function getJobs() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadMore = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoadMoreLoading(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return api/* frontendApi.get */.mR.get("".concat(currentUrl, "&page=").concat(currentPage)).then(function(res) {
                            return setJobsList(jobsList.concat(res.data.jobs));
                        }).catch(function(err) {
                            return console.error(err ? err : "Something went wrong");
                        });
                    case 4:
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error(_ctx.t0);
                    case 9:
                        _ctx.prev = 9;
                        setLoadMoreLoading(false);
                        setCurrentPage(currentPage + 1);
                        return _ctx.finish(9);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    6,
                    9,
                    13
                ]
            ]);
        }));
        return function loadMore() {
            return _ref.apply(this, arguments);
        };
    }();
    var submitSearch = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(payload) {
            var keyword, location, parttime, fulltime, internship, freelance, jobType, posted, fromBrowseButton, typeQuery, locQuery, keywordQuery, postedQuery, arr, checkedType, query, url;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        keyword = payload.keyword, location = payload.location, parttime = payload.parttime, fulltime = payload.fulltime, internship = payload.internship, freelance = payload.freelance, jobType = payload.jobType, posted = payload.posted, fromBrowseButton = payload.fromBrowseButton;
                        typeQuery = "";
                        locQuery = "";
                        keywordQuery = "";
                        postedQuery = "";
                        arr = [
                            {
                                type: freelance,
                                id: 1
                            },
                            {
                                type: fulltime,
                                id: 2
                            },
                            {
                                type: internship,
                                id: 3
                            },
                            {
                                type: parttime,
                                id: 4
                            }, 
                        ];
                        checkedType = arr.filter(function(d) {
                            return d.type;
                        });
                        if (!(0,lodash.isEmpty)(keyword)) {
                            keywordQuery = "&keyword=".concat(keyword);
                        }
                        if (!(0,lodash.isEmpty)(location)) {
                            locQuery = "&location=".concat(location);
                        }
                        if (isAdvance) {
                            if (jobType) typeQuery = "&types=".concat(jobType);
                        } else {
                            if (checkedType.length === 1) {
                                typeQuery = "&types=".concat(checkedType[0].id);
                            }
                            if (checkedType.length > 1) {
                                typeQuery = "&types=";
                                checkedType.map(function(c, i) {
                                    return typeQuery += "".concat(c.id).concat(checkedType.length > i + 1 ? ";" : "");
                                });
                            }
                        }
                        if (posted) postedQuery = "&dateCreated=".concat(posted);
                        query = "".concat(keywordQuery).concat(locQuery).concat(typeQuery).concat(postedQuery);
                        url = "web/jobs?take=10".concat(query);
                        _ctx.prev = 13;
                        setLoading(true);
                        setSearchFilters(payload);
                        _ctx.next = 18;
                        return api/* frontendApi.get */.mR.get(url).then(function(res) {
                            setJobsList(res.data.jobs);
                            setTotal(res.data.total);
                        }).catch(function(err) {
                            return console.error(err ? err : "Something went wrong");
                        });
                    case 18:
                        _ctx.next = 23;
                        break;
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](13);
                        console.error(_ctx.t0);
                    case 23:
                        _ctx.prev = 23;
                        setLoading(false);
                        if (isAdvance) setIsAdvanceSearchResult(true);
                        if (fromBrowseButton) {
                            setIsAdvanceSearchResult(false);
                            setIsAdvance(false);
                        }
                        setCurrentUrl(url);
                        return _ctx.finish(23);
                    case 29:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    13,
                    20,
                    23,
                    29
                ]
            ]);
        }));
        return function submitSearch(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var defaultModalStyles = {
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "0.375rem",
            minWidth: isMobile ? "60vw" : isTablet ? "50vw" : "40vw",
            maxWidth: isMobile ? "80vw" : isTablet ? "70vw" : "40vw",
            maxHeight: "90vh",
            overlfow: "auto",
            zindex: constants_default/* Z_INDECES.MODAL */.F4.MODAL
        },
        overlay: {
            zIndex: constants_default/* Z_INDECES.MODAL_OVERLAY */.F4.MODAL_OVERLAY,
            backdropFilter: "blur(3px)"
        }
    };
    var handleModalClose = function() {
        setIsModalOpen(false);
    };
    var SearchFilterDispay = function(param) {
        var title = param.title, value = param.value, id = param.id;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "items-center flex flex-row space-x-1 label-md text-light justify-between rounded-2xl px-3 py-[6px]",
            style: {
                backgroundColor: isLoading || isLoadMoreLoading ? "#64748b" : "#0E7490"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        title,
                        ": ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "label-sm",
                            children: value
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    disabled: isLoading || isLoadMoreLoading,
                    type: "button",
                    className: "disabled:cursor-not-allowed",
                    onClick: function() {
                        var searchFiltersClone = careers_objectSpread({}, searchFilters);
                        searchFiltersClone[id] = "";
                        submitSearch(searchFiltersClone);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "-mb-px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
                            path: mdi/* mdiClose */.r5M,
                            size: 0.6
                        })
                    })
                })
            ]
        });
    };
    var subscribeToSearch = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(payload) {
            var jobType, posted, keyword, location, email, emailsched, convertedJobtype, convertedPostedDate, body;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        jobType = searchFilters.jobType, posted = searchFilters.posted, keyword = searchFilters.keyword, location = searchFilters.location;
                        email = payload.email, emailsched = payload.emailsched;
                        convertedJobtype = convertJobType(jobType);
                        convertedPostedDate = convertPostedDate(posted);
                        body = {
                            "email": email,
                            "keyword": keyword,
                            "location": location,
                            "jobType": convertedJobtype,
                            "posted": convertedPostedDate,
                            "frequency": emailsched
                        };
                        _ctx.next = 7;
                        return api/* frontendApi.post */.mR.post("web/signup-notifications", body).then(function(res) {
                            react_toastify_esm/* toast.success */.Am.success(res.data.message);
                            handleModalClose();
                        }).catch(function(err) {
                            return react_toastify_esm/* toast.error */.Am.error("Something went wrong");
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function subscribeToSearch(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col space-y-1 py-8 sm:p-7 md:px-16 xl:px-32 bg-background-low-em w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col justify-center -mb-2 sm:flex-row sm:justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    className: "h5 lg:h3 px-2 text-center pb-2 xs:px-6 sm:p-0 text-background-primary-dark",
                                    children: [
                                        "Careers - ",
                                        isAdvance ? "Advanced Search" : "Browse"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                    overrideClassName: "sm:hidden h-2 mb-6 w-[40%]"
                                }),
                                isAdvance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    onClick: function() {
                                        setIsAdvance(false);
                                        setIsAdvanceSearchResult(false);
                                        submitSearch({
                                            keyword: "",
                                            location: "",
                                            fromBrowseButton: true
                                        });
                                    },
                                    buttonType: "secondary",
                                    className: "!py-1.5",
                                    children: "Browse"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    onClick: function() {
                                        setIsAdvance(true);
                                        setJobsList([]);
                                    },
                                    buttonType: "secondary",
                                    className: "!py-1.5",
                                    children: "Advanced Search"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden sm:flex justify-center sm:justify-start sm:pt-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gradient_container/* default */.Z, {
                                overrideClassName: "h-2 mt-2 w-[40%] md:w-[20%] lg:w-[15%]"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                    onSubmit: submitSearch,
                    render: function(param) {
                        var handleSubmit = param.handleSubmit, submitting = param.submitting;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                            onSubmit: handleSubmit,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mx-5 sm:mx-7 md:mx-16 xl:mx-32 my-5 sm:my-10 flex flex-col space-y-3 sm:space-y-4",
                                children: [
                                    isAdvanceSearchResult ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid grid-cols-2 gap-3 lg:flex lg:flex-row lg:gap-0 lg:space-x-3 lg:overflow-auto ",
                                        children: [
                                            searchFilters.keyword && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilterDispay, {
                                                value: searchFilters.keyword,
                                                title: "Keyword",
                                                id: "keyword"
                                            }),
                                            searchFilters.location && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilterDispay, {
                                                value: searchFilters.location,
                                                title: "Location",
                                                id: "location"
                                            }),
                                            searchFilters.jobType && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilterDispay, {
                                                value: convertJobType(searchFilters.jobType),
                                                title: "Job Type",
                                                id: "jobType"
                                            }),
                                            searchFilters.category && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilterDispay, {
                                                value: convertCategory(searchFilters.category),
                                                title: "Category",
                                                id: "category"
                                            }),
                                            searchFilters.posted && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilterDispay, {
                                                value: convertPostedDate(searchFilters.posted),
                                                title: "Posted",
                                                id: "posted"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                blockClassName: "w-full",
                                                name: "keyword",
                                                label: "",
                                                placeholder: "\uD83D\uDD0D Search Keyword"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                blockClassName: "w-full",
                                                name: "location",
                                                label: "",
                                                placeholder: "\uD83D\uDCCD Location"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(isAdvance ? "hidden sm:flex" : "flex", " justify-center sm:justify-start items-center sm:pl-3"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                    type: "submit",
                                                    disabled: submitting,
                                                    className: "!rounded-2xl w-full sm:w-auto",
                                                    children: submitting ? "Searching..." : "Search"
                                                })
                                            })
                                        ]
                                    }),
                                    isAdvance && !isAdvanceSearchResult && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col sm:flex-row sm:space-x-2 space-y-4 sm:space-y-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
                                                name: "jobType",
                                                options: [
                                                    {
                                                        name: "Freelance",
                                                        value: 1
                                                    },
                                                    {
                                                        name: "Full-time",
                                                        value: 2
                                                    },
                                                    {
                                                        name: "Internship",
                                                        value: 3
                                                    },
                                                    {
                                                        name: "Part-time",
                                                        value: 4
                                                    }, 
                                                ],
                                                selectId: "job-type",
                                                placeholder: "Job Type",
                                                label: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
                                                name: "category",
                                                options: [
                                                    {
                                                        name: "Default",
                                                        value: 1
                                                    }, 
                                                ],
                                                selectId: "job-category",
                                                placeholder: "Category",
                                                label: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* default */.Z, {
                                                name: "posted",
                                                options: [
                                                    {
                                                        name: "Today",
                                                        value: 1
                                                    },
                                                    {
                                                        name: "Since Yesterday",
                                                        value: 2
                                                    },
                                                    {
                                                        name: "Less than 7 days ago",
                                                        value: 3
                                                    },
                                                    {
                                                        name: "Less than 30 days ago",
                                                        value: 4
                                                    }, 
                                                ],
                                                selectId: "posted",
                                                label: "",
                                                placeholder: "Date Posted"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "sm:hidden flex justify-center sm:justify-start items-center sm:pl-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                    type: "submit",
                                                    disabled: submitting,
                                                    className: "!rounded-2xl w-full sm:w-auto",
                                                    children: submitting ? "Searching..." : "Search"
                                                })
                                            })
                                        ]
                                    }),
                                    isAdvanceSearchResult && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row space-x-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                className: "!rounded-2xl",
                                                onClick: function() {
                                                    return setIsAdvanceSearchResult(false);
                                                },
                                                children: "Refine Search"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                buttonType: "secondary",
                                                onClick: function() {
                                                    return setIsModalOpen(true);
                                                },
                                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
                                                    path: mdi/* mdiBellRingOutline */.O7L,
                                                    size: 0.8
                                                }),
                                                children: "Subscribe to this earch"
                                            })
                                        ]
                                    }),
                                    !isAdvance && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid grid-cols-2 sm:flex sm:flex-row sm:space-x-2 sm:ml-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_checkbox, {
                                                name: "freelance",
                                                label: "Freelance"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_checkbox, {
                                                name: "fulltime",
                                                label: "Full-time"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_checkbox, {
                                                name: "internship",
                                                label: "Internship"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(form_checkbox, {
                                                name: "parttime",
                                                label: "Part-time"
                                            })
                                        ]
                                    }),
                                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row py-10 space-x-5 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-px flex flex-grow bg-[#EAECF0]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[#667085]",
                                                children: "Loading..."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-px flex flex-grow bg-[#EAECF0]"
                                            })
                                        ]
                                    }) : jobsList.map(function(job) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(job_list_item/* default */.Z, {
                                            id: job.id,
                                            name: job.title,
                                            date: job.created_at,
                                            location: job.location,
                                            status: job.type.name
                                        }, job.id);
                                    }),
                                    !isLoading && jobsList.length >= totalJobs && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row py-10 space-x-5 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-px flex flex-grow bg-[#EAECF0]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[#667085]",
                                                children: "That's all of it!"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-px flex flex-grow bg-[#EAECF0]"
                                            })
                                        ]
                                    }),
                                    jobsList.length < totalJobs && !isLoading && jobsList.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row py-10 space-x-5 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-px flex flex-grow bg-[#EAECF0]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                disabled: isLoadMoreLoading,
                                                onClick: function() {
                                                    return loadMore();
                                                },
                                                className: "px-4 py-[10px] cursor-pointer border rounded-xl disabled:cursor-not-allowed disabled:bg-gray-100",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[#344054]",
                                                    children: isLoadMoreLoading ? "Loading..." : "Load More"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-px flex flex-grow bg-[#EAECF0]"
                                            })
                                        ]
                                    })
                                ]
                            })
                        });
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                    isOpen: isModalOpen,
                    contentLabel: "testa",
                    style: defaultModalStyles,
                    shouldCloseOnOverlayClick: true,
                    shouldCloseOnEsc: true,
                    onRequestClose: handleModalClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                        onSubmit: subscribeToSearch,
                        render: function(param) {
                            var handleSubmit = param.handleSubmit, submitting = param.submitting;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                onSubmit: handleSubmit,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-row justify-between ",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "subheading text-text-color-high-em",
                                                                children: "Subscribe to Personalized Notifications"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "-mt-3 -mr-3",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                type: "button",
                                                                onClick: function() {
                                                                    return handleModalClose();
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
                                                                    path: mdi/* mdiClose */.r5M,
                                                                    size: 0.8
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-body-sm text-text-color-mid-em",
                                                    children: "You are subscribing to jobs matching your current search criteria."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col pt-6 space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-row space-x-2 items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
                                                                path: mdi/* mdiEmail */.XH8,
                                                                size: 0.8
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "label-md text-text-color-high-em",
                                                            children: "Email Notifications"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "pt-1 flex-col flex sm:flex-row sm:space-x-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-body-md text-text-color-mid-em",
                                                            children: "Email Notifications will be sent to you:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-row space-x-3 ",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton, {
                                                                    groupName: "emailsched",
                                                                    value: "daily",
                                                                    label: "Daily"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton, {
                                                                    groupName: "emailsched",
                                                                    value: "weekly",
                                                                    label: "Weekly"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "space-y-2 sm:space-y-0 flex flex-col sm:flex-row sm:items-center sm:space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                            blockClassName: "w-full",
                                                            name: "email",
                                                            label: "",
                                                            placeholder: "Email address",
                                                            required: true,
                                                            type: "email"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                                type: "submit",
                                                                children: "Subscribe"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col pt-4 space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-row space-x-2 items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Icon_default()), {
                                                                path: mdi/* mdiRssBox */.mWw,
                                                                size: 0.8
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "label-md text-text-color-high-em",
                                                            children: "Custom RSS Feed"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-body-md text-text-color-mid-em",
                                                    children: "Your personalized RSS Feed is below, copy the address to your RSS reader."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "space-y-2 sm:space-y-0 flex flex-col sm:flex-row sm:items-center sm:space-x-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "sm:w-[60%] lg:w-[50%] xl:w-[60%] 2xl:w-[70%]",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                                blockClassName: "w-full",
                                                                name: "rss-code",
                                                                label: "",
                                                                readonly: true,
                                                                initialValue: "https://simplewaste.com/wpjobboard/xml/rss/?"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                                onClick: function() {
                                                                    navigator.clipboard.writeText("https://simplewaste.com/wpjobboard/xml/rss/?");
                                                                    react_toastify_esm/* toast.success */.Am.success("Successfully Copied RSS address");
                                                                },
                                                                children: "Copy RSS address"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            });
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var careers = (CareersPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(4931); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);